import React from "react";
import cn from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThLarge } from "@fortawesome/pro-regular-svg-icons/faThLarge";
import { buttonVariants } from "theme/buttonVariants";

const Icon = () => (
    <div className="flex w-full items-center justify-center py-10">
        <FontAwesomeIcon icon={faThLarge} size="6x" />
    </div>
);

const PanelGridComponent = ({
    state: { panels = [], heading = "", selectedCardIndex = null },
    isEditMode,
    onChange,
    focused,
}) => {
    return (
        <div>
            <div className="mb-[30px] flex flex-col items-center justify-between md:flex-row">
                <h2
                    data-testid="product-relations__title"
                    className={
                        "!lg:text-[40px] !lg:leading-[46px] !mb-0 text-center !text-[30px] !leading-[34px] text-brand-black"
                    }
                >
                    {heading}
                </h2>
            </div>

            {panels?.length > 0 ? (
                <div className="grid grid-cols-1 gap-[15px] md:grid-cols-2 lg:grid-cols-3">
                    {panels.map((panel, idx) => {
                        return (
                            <div
                                key={`panels_${idx}`}
                                data-testid={`panels__item-${idx}`}
                                style={{
                                    boxShadow:
                                        selectedCardIndex === idx &&
                                        focused &&
                                        "inset 0 0 0 3px red",
                                    backgroundImage: panel.backgroundImage
                                        ? `url("${panel.backgroundImage}")`
                                        : "none",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                }}
                                className={`flex w-full flex-col gap-y-[15px] bg-brand-light-grey px-[30px] py-[50px]`}
                                onClick={(e) => {
                                    if (isEditMode) {
                                        e.preventDefault();
                                        onChange({
                                            selectedCardIndex: idx,
                                        });
                                    }
                                }}
                            >
                                <div className="relative flex h-full w-full flex-col items-center justify-start gap-y-[15px] text-brand-white">
                                    <h3 className="text-center">
                                        {panel.heading}
                                    </h3>

                                    <p
                                        className="mb-0 flex-grow text-center text-[16px] leading-[22px]"
                                        dangerouslySetInnerHTML={{
                                            __html: panel.text,
                                        }}
                                    />

                                    {panel.buttonLink && (
                                        <a
                                            href={panel.buttonLink}
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                            className={cn(
                                                (
                                                    buttonVariants[
                                                        panel.buttonColour
                                                    ] || buttonVariants.primary
                                                ).solidClasses,
                                                "!no-underline !font-bold mt-[15px]"
                                            )}
                                        >
                                            {panel.buttonText}
                                        </a>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <Icon />
            )}
        </div>
    );
};

export default PanelGridComponent;
